import { useContext, useEffect, useState } from "react"
import { BsPlus, BsX } from "react-icons/bs"
import userContext from "../../../../../dataContext"

// Concierges who can see a back (backAccess): list, remove and add
export default function BackAccess({ bookingScope }) {
    const context = useContext(userContext)
    const [ids, setIds] = useState([])
    const [selected, setSelected] = useState("")
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        setLoading(true)
        context.apiReducer('getBackAccess', {}, bookingScope)
            .then((backAccess) => setIds(backAccess || []))
            .catch(() => setIds([]))
            .finally(() => setLoading(false))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bookingScope.id, bookingScope.mongoId, bookingScope.propertyId])

    const save = (backAccess) => {
        setLoading(true)
        context.apiReducer('modifyBooking', { backAccess }, bookingScope)
            .then(() => {
                setIds(backAccess)
                setSelected("")
            })
            .catch(() => { })
            .finally(() => setLoading(false))
    }

    const concierges = context.data.people.Concierge || []
    const available = concierges.filter((concierge) => !concierge.archive && !ids.includes(concierge.id))

    return (
        <div>
            <div className={"d-flex flex-wrap align-items-center gap-2 pb-2"}>
                <span>Concierges ayant la visibilité du back :</span>
                {ids.length === 0 && !loading ?
                    <span className={"badge rounded-pill bg-warning text-white"}>Aucun concierge</span>
                    : ids.map((id) => {
                        const concierge = concierges.find((el) => el.id === id)
                        return (
                            <span key={id} className={"badge rounded-pill " + (concierge ? "bg-secondary text-white" : "bg-danger")}>
                                {concierge ? concierge.lastName + " " + concierge.name : "ERR " + id}
                                <BsX role={"button"} className={"ms-1"} title={"Retirer"}
                                    onClick={() => !loading && save(ids.filter((el) => el !== id))} />
                            </span>
                        )
                    })
                }

            </div>
            <div className={"input-group input-group-sm w-auto"} style={{ paddingBottom: "10px" }}>
                <select className={"form-select"} value={selected} disabled={loading}
                    onChange={(e) => setSelected(e.target.value)}>
                    <option value={""}>Ajouter un concierge</option>
                    {available.map((concierge) => (
                        <option key={concierge.id} value={concierge.id}>
                            {concierge.lastName} {concierge.name}
                        </option>
                    ))}
                </select>
                <button type={"button"} className={"btn btn-light"} disabled={!selected || loading}
                    onClick={() => save([...ids, selected])}>
                    <BsPlus />
                </button>
            </div>
        </div>
    )
}
